import { API_URL } from "./Config";
import { formatDate } from "./DateUtils";
import { IDetailsResponse } from "./IDetailsResponse";
import { GetLicenseDetailsAsync } from "./LicenceDetails";

export interface ITaskDetails extends IDetailsResponse {
  taskid: string;
  type: string;
  licenceid: string;
  reference: string;
  status: string;
  datesubmitted: string;
  duedate: string;
  subject: string;
  sender: string;
  recipient: string;
  details: string;
  category: string;
  subcategory: string;
  observation: string;
  description: string;
  regardingobjectid: string;
  licence_regno?: string;
  profileNo?: string;
}

export const isFindingOrRecommentation = (type: string) => {
  return type === "SV Finding" || type === "SV Recommendation";
};

export const isActionOrInstruction = (type: string) => {
  return type === "Action" || type === "Instruction";
};

export async function GetTaskDetailsAsync(
  taskId: string
): Promise<ITaskDetails> {
  var url = `${API_URL}/Task/byid?task_id=${taskId}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/finding-details`;
  }

  var response = await fetch(url);
  var body = <ITaskDetails>await response.json();

  const licenceDetails = await GetLicenseDetailsAsync(body.licenceid);

  return <ITaskDetails>{
    response: response,
    taskid: body.taskid,
    type: body.type,
    licenceid: body.licenceid,
    reference: body.reference,
    status: body.status,
    datesubmitted: formatDate(body.datesubmitted),
    duedate: formatDate(body.duedate),
    subject: body.subject,
    sender: body.sender,
    recipient: body.recipient,
    details: body.details,
    category: body.category,
    subcategory: body.subcategory,
    observation: body.observation,
    description: body.description,
    profileNo: licenceDetails.licenceprofile_number,
    licence_regno: licenceDetails.reg_no,
  };
}
